import Common from '../common'
var Js = Common('card')
export default {
	name: 'card',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'product_no',
					label: '商品NO',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 100
				},
				{
					key: 'title',
					label: '名称',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入名称',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.title = val;
							} else {
								delete self.searchItem.title;
							};
				
						},
					},
				},
				{
					key: 'price',
					label: '售价',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'balance',
					label: '价值金额',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'stock',
					label: '库存',
					application: ['编辑', '添加'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'mainImg',
					label: '展示图',
					customSlot: 'mainImg',
					application: ['编辑', '添加'],
					componentName: 't-upload',
					listType: 'normal',
					limit: 10,
					dialogStyle: 'width:90%',
					width: 100
				},
				// {
				// 	key: "active_status",
				// 	label: '激活状态',
				// 	application: ['编辑'],
				// 	listType: 'normal',
				// 	componentName: 'sls-select',
				// 	optionsName: 'statusOptions',
				// 	defaultProps: {
				// 		label: 'text',
				// 		value: 'value',
				// 	},
				// 	formatter: function(val) {
				// 		if (val.active_status == 1) {
				// 			return '已激活';
				// 		} else {
				// 			return '未激活';
				// 		};
				// 	},
				// 	width:120
				// },
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};

						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 80
				},
			],
			// 按钮配置
			btn_info: [{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							if (self.submitData.category_id == 0) {
								return false;
							};
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_productUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'header',
					text: function(data) {
						return '添加'
					},
					func: {
						apiName: function(self) {
							return "api_productAdd"
						},
						formData: function(self) {
							var data = {
								title: '',
								content: '',
								price: '',
								mainImg: [],
								bannerImg: [],
								img_array: []
							};
							return data
						},
						postData: function(self) {
							self.submitData.type = 3;
							self.submitData.category_id = 18;
							if(self.submitData.stock){
								self.submitData.stock = 9999999;
							}
							var postData = {
								data: self.submitData
							};
							postData.saveAfter = [{
								tableName: 'ProductDate',
								FuncName: 'add',
								data: {
									res: {
										product_no: 'product_no'
									},
									type: 1,
									is_template: 0,
									stock: self.submitData.stock
								}
							}]
							console.log(postData)

							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return 'SKU管理'
					},
					funcType: 'func',
					func: {
						func: function(self) {
							self.$router.push({
								path: '/home/sku',
								name: 'SKU管理',
								params: {
									product_id: self.originFormData.id,
									path: '/home/product',
									delKeepAlive: true
								}
							});
						},
					},
				},
			],

			searchItem: {
				type: 3,
				category_id:18
			},
			startSearchItem: {
				type: 3,
				category_id:18
			},
			optionData: {
				labelOptions: [],
				skuOptions: [],
				statusOptions: [{
					text: '已激活',
					value: 1
				}, {
					text: '未激活',
					value: 0
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			this.initLabelData();
		},

		async initLabelData(isNew) {

			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				type: 2,
				parentid:7
			};
			var res = await self.$$api_labelGet({
				data: postData
			});
			self.optionData.labelOptions = res.info.data;

		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {

				realStock: {
					tableName: 'ProductDate',
					middleKey: 'product_no',
					key: 'product_no',
					condition: '=',
					info: ['stock']
				}
			}

			var res = await self.$$api_productGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		}

	},


}



// WEBPACK FOOTER //
// ./src/views/product/card.js